module.exports = __webpack_public_path__ + "img/469.59c5ba15.jpg";